import axios from 'axios';
import { getToken, setToken, isTokenExpiringSoon } from './auth';
import router from '@/router';
import { useUserStore } from '@/stores/user';

// Crear una instancia de axios en lugar de modificar la configuración global
const api = axios.create({
  // baseURL: 'http://localhost:8000/api'
  baseURL: import.meta.env.VITE_API_ENDPOINT
});

api.interceptors.request.use(async (config) => {
  // console.log('config.url', config.url);
  if (['login', '/renew'].includes(config.url)) {
    // console.log(`Excluyendo ${config.url} del interceptor`);
    return config;
  }

  let token = getToken();
  // console.log('[AXIOS] Interceptor request: token actual:', token ? 'presente' : 'ausente');
  if (token) {
    if (isTokenExpiringSoon(token)) {
      // console.log('[AXIOS] Token está por expirar, intentando renovar...');
      try {
        const { data } = await api.post('/renew', {}, {
          headers: { Authorization: `Bearer ${token}` }
        });
        token = data.token;
        setToken(token);
        // console.log('[AXIOS] Token renovado exitosamente');
      } catch (e) {
        // console.warn('[AXIOS] Falló la renovación del token:', e.message);
        localStorage.removeItem('token');
        token = null;
      }
    }
    // console.log('[AXIOS] Validando token final...');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      // console.log('[AXIOS] Authorization header agregado al request');

      // Agregar negocio_id si está seleccionado
      const userStore = useUserStore();
      if (userStore.negocioSeleccionado?.id) {
        config.headers['X-Negocio-Id'] = userStore.negocioSeleccionado.id;
        // console.log('[AXIOS] X-Negocio-Id header agregado:', userStore.negocioSeleccionado.id);
      }
    } else {
      // console.warn('[AXIOS] No hay token después de intentar renovar. Redirigiendo a login.');
      router.push('/login');
      throw new axios.Cancel('No token, redirigiendo a login');
    }
  } else {
    // console.warn('[AXIOS] No hay token en request inicial. Redirigiendo a login.');
    router.push('/login');
    throw new axios.Cancel('No token, redirigiendo a login');
  }
  return config;
}); 

// Interceptor de respuesta para manejar expiración de sesión
api.interceptors.response.use(
  response => response,
  error => {
    // console.log('error.response.status', error.response.status);
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      // console.error('[AXIOS] Respuesta 401/403: sesión expirada o token inválido.');
      localStorage.removeItem('token');
      try {
        const userStore = useUserStore();
        userStore.logout && userStore.logout();
      } catch (e) { 
        // console.error('[AXIOS] Error al hacer logout en el store:', e); 
      }
      router.push('/login');
      if (error.response.status !== 401) {
        alert('Tu sesión ha expirado. Por favor, inicia sesión nuevamente.');
      }
    } else {
      if (error.response) {
        // console.error('[AXIOS] Error de respuesta:', error.response.status, error.response.data);
      } else {
        // console.error('[AXIOS] Error desconocido en respuesta:', error);
      }
    }
    return Promise.reject(error);
  }
);

export default api; 